import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, effect, inject } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { HelperService } from './core/helper/helper.service';
import { MatDialog } from '@angular/material/dialog';
import { WarningComponent } from './modules/quoting-tool/warning/warning.component';
import { CommonService } from './core/services/common.service';
import { environment } from 'src/environments/environment';
import { MessagingService } from './core/services/pushNotification.service';
import { QuotingToolService } from './modules/quoting-tool/quoting-tool.service';
import { NetworkStatusService } from './core/services/network-status.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LayoutService } from './shared/layout/layout.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  // styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Rapidise - Customer';
  currentMessage: any = null;
  imagePath:any=environment.image_path;
  firebase_url=environment.firebase_registration_path;
  isLoading:boolean=false;
  percentageCount:any;
  displayText:boolean=false
  getPercentage = this.qouteTool.getQuotePercentage();

  getLoading = this.commonService.getloadingState();
  getUploadProgress = this.commonService.getUploadProgress();
  uploadProgress: number | null = null;

  private isModalOpen = false; // Track modal state

  // Access signal in template or TS code
  private readonly network = inject(NetworkStatusService);
  readonly isOnline = this.network.online;
  // toObservable must be called in an injection context (class field initializer, not ngOnInit)
  private readonly isOnline$ = toObservable(this.isOnline);
  private networkSub: Subscription | null = null;
  snackBarRef:any;

  constructor(private _snackBar:MatSnackBar,private cdr:ChangeDetectorRef,private commonService:CommonService,private router: Router,private layoutService:LayoutService, private helper: HelperService, private dialog: MatDialog,  private messagingService: MessagingService,private qouteTool:QuotingToolService) {
    effect(() => {
      this.isLoading = this.getLoading();
      this.percentageCount = this.getPercentage();
      if(this.percentageCount == '100%'){
        this.displayText =true
      }else{
        this.displayText =false
      }
      this.cdr.detectChanges();
    }, { allowSignalWrites: true });

    effect(() => {
      this.uploadProgress = this.getUploadProgress();
    }, { allowSignalWrites: true });
  }




  ngOnInit() {
    this.networkSub = this.isOnline$.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe((online: boolean) => {
      if (!online) {
        if (this.snackBarRef) {
          this.snackBarRef.dismiss();
        }
        this.snackBarRef = this._snackBar.open('Connection lost. Please check your internet.', 'Close', {
          horizontalPosition: 'center',
          verticalPosition: 'top'
        });
      } else {
        if (this.snackBarRef) {
          this.snackBarRef.dismiss();
          this.snackBarRef = this._snackBar.open('You are connected to the internet.', 'Close', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 5000
          });
          this.snackBarRef.afterDismissed().subscribe(() => {
            this.snackBarRef = undefined;
          });
          // Re-fetch permissions to clear any revoked temporary access
          this.layoutService.updateProfileUpdate(new Date().getTime());
        }
      }
    });

    // this.registerServiceWorker();
    // this.messagingService.requestPermission();
    // this.messagingService.receiveMessage();
    // this.messagingService.currentMessage.subscribe({
    //   next: (message) => {
    //     if (message) {
    //       // Handle the received message
    //       this.currentMessage = message;
    //       // You can show a notification here if needed
    //     } else {
    //       console.log("Message was null");
    //     }
    //   },
    //   error: (error) => {
    //     console.error("Error in message subscription:", error);
    //   }
    // })

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        let accessToken = localStorage.getItem("customer_access_token");
          if (accessToken) {
            this.router.navigate(["/customer"]);
          } else {
            this.helper.Logout();
          }
      }
    });
  }


  private isReloading = false; // Flag to track if the page is reloading
  private isNavigating = false; // Flag to track if the user navigated away

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.router.url.includes("stepper-forms") || this.router.url.includes("e-quotation")) {
      // Check if the user is reloading the page
      const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      
      if (navigation.type === 'reload') {
        this.isReloading = true; // Set flag to true if it's a reload
      }

      const token = !!localStorage.getItem("customer_access_token");
      const member_token = !!localStorage.getItem("quote_token");

      if (!token && !member_token) {
        // Display the warning message before the user leaves the page
        event.preventDefault();
      
        this.isNavigating = true;
        setTimeout(() => {
          this.showWarningModal();
        }, 100); 
      } else {
        // If the token is present, allow the page to reload without any warning
        event.preventDefault();
      }
      
    }
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
    switch(event.key){
      case 'logout':
        this.helper.ClearStorageData();
        this.router.navigate(["accounts/login"]);
        break;
      case 'customer_access_token':
        const epochTime = new Date().getTime();
        this.layoutService.updateProfileUpdate(epochTime);
        break;
    }
  }

  showWarningModal(): void {
    this.isModalOpen = true; // Set the modal state to open
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '500px',
      panelClass: 'custom-dialog',
      data: { source: 'showWarningModal' }
    });
    if(this.router.url == "/quotations"){
      dialogRef.close();  
    }
    dialogRef.afterClosed().subscribe(() => {
      this.isModalOpen = false; // Reset the modal state after it closes
      const customer_access_token = localStorage.getItem('customer_access_token');
      if(customer_access_token===undefined && this.router.url.includes("e-quotation")){
        localStorage.setItem('currentStepIndex','1')
      }
      if(customer_access_token===undefined && this.router.url.includes("stepper-forms")){
        localStorage.setItem('currentStepIndex','3')
      }
    });
  }

  private registerServiceWorker() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
      .register(this.firebase_url, { scope: '/' }) // Adjust the scope to your app's subdirectory [ FOR BUILDS ]
        .then((registration) => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }
  }

  private pageUnloading = false; // Track if the page is being unloaded

  @HostListener('window:unload', ['$event'])
  onUnload(): void {
    // Set the flag indicating the page is being unloaded
    this.pageUnloading = true;
    this.isNavigating = false; // Reset the flag since the page is leaving
  }

  ngOnDestroy(): void {
    this.networkSub?.unsubscribe();
  }

}
